export default "__VITE_ASSET__DVoveTZ6__"